import { connect } from 'react-redux'
import { closeWidget } from './actions'
import component from './component'


const mapStateToProps = state => ({
    pathname: state.router.location.pathname
})

export default connect(
    mapStateToProps,
    { closeWidget }
)(component)
